module.exports = __webpack_public_path__ + "img/Avatar.b0bf6db3.jpg";